/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowreview2Inputs */

const en_aiflowreview2 = /** @type {(inputs: Aiflowreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almost done. Have a last look, then open it in the form or save it as a draft.`)
};

const de_aiflowreview2 = /** @type {(inputs: Aiflowreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast fertig. Schau noch einmal drüber, dann geht es ins Formular oder direkt als Entwurf.`)
};

/**
* | output |
* | --- |
* | "Almost done. Have a last look, then open it in the form or save it as a draft." |
*
* @param {Aiflowreview2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowreview2 = /** @type {((inputs?: Aiflowreview2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowreview2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowreview2(inputs)
	return de_aiflowreview2(inputs)
});
export { aiflowreview2 as "aiFlowReview" }